import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { sendCommerceNewRelicError as sendError } from '@chegg/commerce-utils';
import { NewRelicComponentName, NewRelicComponentVersion } from '../constants/newRelic';

/**
 * TODO: Move this util into the `packages/Utils` package and replace any duplicate utils e.g. in PaymentMethods
 * See https://chegg.atlassian.net/browse/SQUAA-312
 */

/**
 * Sends an error to New Relic with the errors and One Click component details
 * @param error A string describing the error
 * @param extras An optional object containing additional error data
 */
export var sendNewRelicError = function sendNewRelicError(error, extras) {
  sendError({
    error: error,
    componentName: NewRelicComponentName,
    componentVersion: NewRelicComponentVersion,
    extras: _objectSpread({
      referrer: typeof document !== 'undefined' ? document.location.href : ''
    }, extras)
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/utils/NewRelicUtils.js
// module id = 385
// module chunks = 11